import React, { useCallback,useEffect, useState, useRef } from "react";
import styled, { withTheme } from "styled-components";
import ContentEditable from "react-contenteditable";
import { useDebounce } from 'use-lodash-debounce'


export default withTheme((props) => {
  const { extra = {}, theme,save, id } = props;
  const { label = 'No label', tagName = 'h1', textAlign='left', style = {} } = extra;
  const [value, setValue] = useState(label);
  const debouncedValue = useDebounce(value, 500);

  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      save({ _id : id, key: 'label', value: debouncedValue });
    } else {
      didMountRef.current = true;
    }
  }, [debouncedValue,id]); // including save as linting suggest will break the update. 

  useEffect(() => {
    if( label !== value ) {
      setValue(label)
    }
  }, [label]);

  
  const handleChange = useCallback( e => {
    setValue(e.target.value)
  }, [])

  const themeStyle = theme[tagName] ? theme[tagName] : {}

  const headingTheme = theme.Heading ? theme.Heading : {}

  // TODO: add more style here!!
  const newStyle = {
    fontFamily: themeStyle.fontFamily ? themeStyle.fontFamily : 'inherit',
    fontSize: themeStyle.fontSize ? themeStyle.fontSize + themeStyle.fontSizeUnit : 'inherit',
    lineHeight: themeStyle.lineHeight ? themeStyle.lineHeight + themeStyle.lineHeightUnit : 'inherit',
    color: style.color ? style.color : themeStyle.color ? themeStyle.color : 'inherit',
    background: 'transparent'
  }

  return <ContentEditable
    className="editable"
    tagName={tagName}
    style={{...headingTheme,...newStyle, textAlign, }}
    html={value} // innerHTML of the editable div
    disabled={false} // use true to disable edition
    onChange={handleChange} // handle innerHTML change
    onKeyDown={e => e.keyCode === 13 && e.preventDefault()}
  />

});
